import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useMemo } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIList from 'UIComponents/list/UIList';
import MainSection from 'ecosystem-marketplace-core/components/layout/MainSection';
import MainSectionInner from 'ecosystem-marketplace-core/components/layout/MainSectionInner';
import ValidI18nMessage from 'ecosystem-marketplace-core/js/i18n/components/ValidI18nMessage';
import { getIsPrerenderUserAgent } from 'ecosystem-marketplace-core/utils/userAgent';
import RouterNavButton, { ActiveDropdownButton, DropdownButton } from './RouterNavButton'; // @ts-expect-error untyped module

import { useEmbedContext } from '../../../hooks/useEmbedContext';
import { useIsActiveRoute } from '../../../hooks/useIsActiveRoute'; // @ts-expect-error untyped module

import { getIsUngatedForModulesStorefront } from '../../../selectors/auth';
import { createSelectCollectionSlugs, createSelectDisplayedCollections } from '../../../slices/collections/collectionsSlice';
import { getModulesStorefrontRoute, getThemeCollectionPreviewRoute, getThemesStorefrontRoute } from '../../../utils/urls';
import { useOfferingType } from '../../../context/OfferingTypeContext';
export default function DesktopBrowseBar({
  hasActiveOfferingType,
  previewCollectionId
}) {
  const {
    isEmbedded
  } = useEmbedContext();
  const isPrerender = getIsPrerenderUserAgent();
  const selectDisplayedCollections = useMemo(() => createSelectDisplayedCollections(previewCollectionId), [previewCollectionId]);
  const collections = useSelector(selectDisplayedCollections);
  const selectCollectionSlugs = useMemo(() => createSelectCollectionSlugs(previewCollectionId), [previewCollectionId]);
  const collectionSlugs = useSelector(selectCollectionSlugs);
  const activeCollectionRoutes = useMemo(() => collectionSlugs.map(slug => getThemesStorefrontRoute(slug)).concat(['/']), [collectionSlugs]);
  const isActiveCollectionRoute = useIsActiveRoute({
    pathname: previewCollectionId ? getThemeCollectionPreviewRoute(previewCollectionId) : activeCollectionRoutes
  }, true);
  const isUngatedForModulesStorefront = useSelector(getIsUngatedForModulesStorefront);
  const offeringType = useOfferingType();
  const activeOfferingType = hasActiveOfferingType ? offeringType : null;
  return /*#__PURE__*/_jsx(MainSection, {
    className: "p-y-3",
    color: "light",
    children: /*#__PURE__*/_jsx(MainSectionInner, {
      children: /*#__PURE__*/_jsx(UIFlex, {
        justify: "center",
        children: isUngatedForModulesStorefront && !isEmbedded ? /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(RouterNavButton, {
            active: activeOfferingType === 'THEME',
            "data-test-id": "storefront-nav-themes-button",
            to: getThemesStorefrontRoute('all'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.storefront.nav.themes"
            })
          }), /*#__PURE__*/_jsx(RouterNavButton, {
            active: activeOfferingType === 'MODULE',
            "data-test-id": "storefront-nav-modules-button",
            to: getModulesStorefrontRoute(),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.storefront.nav.modules"
            })
          })]
        }) : /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(UIDropdown, {
            Button: isActiveCollectionRoute ? ActiveDropdownButton : DropdownButton,
            buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.storefront.nav.discover"
            }),
            "data-test-id": "storefront-nav-discover-dropdown",
            defaultOpen: isPrerender,
            children: /*#__PURE__*/_jsxs(UIList, {
              children: [/*#__PURE__*/_jsx(RouterNavButton, {
                to: getThemesStorefrontRoute(),
                exact: true,
                "data-test-id": "storefront-nav-collection-button::all",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "marketplace-assets-ui.storefront.nav.allCollections"
                })
              }), collections.map(({
                id,
                draftListing,
                publishedListing
              }) => {
                const collectionListing = id === previewCollectionId ? draftListing : publishedListing;

                if (!collectionListing) {
                  return null;
                }

                const {
                  slug,
                  title
                } = collectionListing;
                return /*#__PURE__*/_jsx(RouterNavButton, {
                  to: getThemesStorefrontRoute(slug),
                  exact: true,
                  "data-test-id": `storefront-nav-collection-button::${slug}`,
                  children: /*#__PURE__*/_jsx(ValidI18nMessage, {
                    defaultValue: title,
                    message: `marketplace-assets-ui.collections.collection_${id}.title`
                  })
                }, id);
              })]
            })
          }), /*#__PURE__*/_jsx(RouterNavButton, {
            active: !isActiveCollectionRoute,
            "data-test-id": "storefront-nav-themes-button",
            to: getThemesStorefrontRoute('all'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.storefront.nav.themes"
            })
          })]
        })
      })
    })
  });
}